<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Debounce-Timer und Antwort-Sequenz je Komponenteninstanz
    this._debounce = null;
    this._reqSeq = 0;
    this.geocoder = null;

    GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
    });
  },

  beforeDestroy() {
    this._cancelPending();
  },

  watch: {
    search(val) {
      if (val && val !== this.select) {
        this.querySelections(val);
      } else if (!val) {
        this._reset();
      }
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    _cancelPending() {
      if (this._debounce != null) {
        clearTimeout(this._debounce);
        this._debounce = null;
      }
      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }
      // Verspätete Antworten laufender Anfragen invalidieren
      this._reqSeq++;
    },

    _reset() {
      this._cancelPending();
      this.items = [];
      this.loading = false;
    },

    querySelections(value) {
      this.loading = true;

      if (this._debounce != null) {
        clearTimeout(this._debounce);
      }
      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      const seq = ++this._reqSeq;

      this._debounce = setTimeout(() => {
        if (!this.geocoder) {
          if (seq === this._reqSeq) {
            this.loading = false;
          }
          return;
        }

        this.geocoder
          .autocomplete(value)
          .then(items => {
            // Nur die jüngste Antwort darf Treffer verändern
            if (seq !== this._reqSeq) {
              return;
            }
            this.items = Array.isArray(items) ? items.slice() : [];
          })
          .catch(() => {
            if (seq !== this._reqSeq) {
              return;
            }
            this.items = [];
          })
          .finally(() => {
            if (seq === this._reqSeq) {
              this.loading = false;
            }
          });
      }, 150);
    },

    change(o) {
      // Auswahl beendet Timer und ausstehende Anfragen
      this._cancelPending();
      this.$emit("change", o);
    }
  }
};
</script>
